<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>优惠券</span>
				<el-button class="button" @click='edit("")' type="success">新增</el-button>
			</div>
		</template>
		<el-table :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据"
		 v-loading="loading" :data="list.data" style="width: 100%;" border highlight-current-row>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
			<el-table-column prop="coupon_id" label="优惠券码"></el-table-column>
			<el-table-column prop="coupon_name" label="优惠券码名称"></el-table-column>
			<el-table-column prop="coupon_num" label="发放数量"></el-table-column>
			<el-table-column label="使用门槛">
				<template #default='scope'>
					<span>{{thresholdAll[scope.row.threshold-1].label}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="full_money" label="金额满多少可使用"></el-table-column>
			<el-table-column prop="reduce_money" label="立减"></el-table-column>
			<el-table-column label="限制分类">
				<template #default='scope'>
					<el-tag effect="dark" size='medium' type="success">{{scope.row.get_product_sale_type_name.product_sale_name}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="开始时间">
				<template #default="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template #default="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column align="right" width="200">
					<template #header>
						<span>操作</span>
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button type="danger" size="medium" @click="destroy(scope.row)">删除</el-button>
					</template>
				</el-table-column>
		</el-table>
		<pages :total="total" :page-size="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
	</el-card>
	<el-dialog :title='title' v-model="dialogFormVisible">
		<el-form label-position='left' :model="item" ref="form" :rules="rules" label-width="150px">
			<el-form-item label="优惠券码名称" prop="coupon_name">
				<el-input v-model="item.coupon_name" size="small" placeholder="优惠券码名称"></el-input>
			</el-form-item>
			<el-form-item label="发放数量" prop="coupon_num">
				<el-input-number controls-position="right" :min="1" :max="1" clearable size="medium" v-model="item.coupon_num"
				 placeholder="发放数量" autocomplete="off"></el-input-number>
			</el-form-item>
			<el-form-item label="金额满多少" prop="full_money">
				<el-input-number controls-position="right" :min="1" clearable size="medium" v-model="item.full_money"
				 placeholder="金额满多少" autocomplete="off"></el-input-number>
			</el-form-item>
			<el-form-item label="金额立减" prop="reduce_money">
				<el-input-number controls-position="right" :min="1" clearable size="medium" v-model="item.reduce_money"
				 placeholder="金额立减" autocomplete="off"></el-input-number>
			</el-form-item>
			<el-form-item label="使用门槛" prop="threshold">
				<el-select v-model="item.threshold" placeholder="使用门槛" clearable>
					<el-option v-for="items in thresholdAll" :key="items.value" :label="items.label" :value="items.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="限制分类" prop="condition_sale_type">
				<el-select filterable v-model="item.condition_sale_type" clearable placeholder="请选择">
					<el-option v-for="items in all_product_sale_type" :key="items.id" :label="items.product_sale_name" :value="items.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="积分时间">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-form-item prop="start_time">
							<el-input v-model="item.start_time" type="date" placeholder="开始时间"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="end_time">
							<el-input v-model="item.end_time" type="date" placeholder="结束时间"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import pages  from'../common/Pagination.vue'
	export default {
		name: 'CouponPromotion',
		components: {
			pages,
		},
		data() {
			return {
				dialogFormVisible: false,
				title: '新增',
				total: 0,
				currentPage: 1,
				pageSize: 10,
				loading: true,
				list: [],
				item: {
					coupon_name:'',
					coupon_num: 1,
					threshold: '',
					full_money:1,
					reduce_money:1,
					condition_sale_type:'',
					start_time: '',
					end_time: '',
				},
				all_product_sale_type:[],
				thresholdAll: [{
				  value: '1',
				  label: '满减'
				}],
				rules: {
					coupon_name: [{
						required: true,
						message: '请填写优惠券名称',
						trigger: 'blur'
					}],
					coupon_num: [{
						required: true,
						message: '请填写优惠券发放数量',
						trigger: 'blur'
					}],
					threshold: [{
						required: true,
						message: '请选择使用门槛',
						trigger: 'change'
					}],
					full_money: [{
						required: true,
						message: '请填写优惠券满减金额',
						trigger: 'blur'
					}],
					reduce_money: [{
						required: true,
						message: '请填写优惠券立减金额',
						trigger: 'blur'
					}],
					condition_sale_type: [{
						required: true,
						message: '请选择限制商品类型',
						trigger: 'change'
					}],
					start_time: [{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time: [{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			edit(row) {
				console.log(row)
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑';
					temp.start_time=this.timestampToTime(temp.start_time);
					temp.end_time=this.timestampToTime(temp.end_time);
					temp.condition_sale_type = parseInt(temp.condition_sale_type)//由于数据库设置的是string 类型 所以这里强制转换为 整型
					this.item = temp;
				} else {
					this.resetObj(this.item)
					this.item.condition_sale_type = ''    // 去除默认值
				}
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			destroy(row) {
				console.log(row.id)
				let id = row.id
				// alert(id)
				// return false;
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/promotion/couponPromotionDel', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getCouponPromotion();
				})
			},
			submit() {
				console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						// console.log(this.item)
						// return false;
						this.httpPost({
							url: '/admin/promotion/couponPromotionUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getCouponPromotion();
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				})

			},
			getProductSaleType() {
				this.httpPost({
					url: '/admin/product/productSaleTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_sale_type = temp;
			
				}).catch((err) => {})
			},
			handleSizeChangeFun(page){
				this.pageSize = page;
				this.getCouponPromotion();
			},
			handleCurrentChangeFun(page){
				this.currentPage = page;
				let str = '';
				str = this.$route.path+'?p='+page;
				this.$router.push(str);
				this.getCouponPromotion();
			},
			getCouponPromotion(){
				this.httpPost({
					url: '/admin/promotion/couponPromotionList',
					data:{p:this.currentPage,routePath: this.$route.path},
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.total = re.data.total;
					this.currentPage = re.data.currentPage;
					this.loading = false;
							
				}).catch((err) => {})
			}
		},
		created() {
			this.getProductSaleType();
			this.getCouponPromotion();
		}
	}
</script>

<style>
</style>
